var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7911C0 11.858 1.567 10.291 3.5 10.291H25.7685C27.7015 10.291 29.2685 11.858 29.2685 13.7911C29.2685 15.7241 27.7015 17.2911 25.7685 17.2911H7V56.0005H45.709V37.2318C45.709 35.2988 47.276 33.7318 49.209 33.7318C51.142 33.7318 52.709 35.2988 52.709 37.2318V59.5005C52.709 61.4335 51.142 63.0006 49.209 63.0006H3.5C1.567 63.0006 0 61.4335 0 59.5005V13.7911Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28.0003L49 7.00008L56 14.0002L35 35.0004H28.5C28.2239 35.0004 28 34.7765 28 34.5004V28.0003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 12.2501L50.75 5.25006L54.9393 1.06068C55.5251 0.474884 56.4749 0.474886 57.0607 1.06068L61.9394 5.93942C62.5251 6.52521 62.5251 7.47495 61.9394 8.06073L57.75 12.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleEditIcon);
export default __webpack_public_path__ + "static/media/simple-edit-icon.d06dbcb39ab99caee420c9ec1f7578e7.svg";
export { ForwardRef as ReactComponent };